module.exports = __webpack_public_path__ + "static/media/CloseXBlue.ae168099.svg";